export default __webpack_public_path__ + "static/Plesk-SiteJet-1024x597-2ae0c296ba5514a87f240eed28d6e625.png";